import { render, staticRenderFns } from "./Form2FA.vue?vue&type=template&id=5eba3114&scoped=true"
import script from "./Form2FA.vue?vue&type=script&lang=js"
export * from "./Form2FA.vue?vue&type=script&lang=js"
import style0 from "./Form2FA.vue?vue&type=style&index=0&id=5eba3114&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5eba3114",
  null
  
)

export default component.exports